import { ControllerProps } from "csi/middleware/common";
import SaveDialog from "designSystem/components/dialog/SaveDialog";
import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { createPushFromStyleStore } from "./PushFromStyleService";
import { PushFromStyleStoreeContext } from "./PushFromStyleStore";
import { PushSettingsForm } from "./PushSettingsForm";

export const PushFromStyleDialog: FunctionComponent<ControllerProps> = observer((props) => {
	const { actionController, onClose, onSave } = props;
	const loc = useLocale();
	const store = useLocalReactionStore(() => createPushFromStyleStore(actionController, loc, onSave));
	const { actionMessage, titleRes, save, dsLinesSelected } = store || {};

	return (
		<>
			{store && (
				<PushFromStyleStoreeContext.Provider value={store}>
					<SaveDialog
						actionMessage={actionMessage}
						disableSave={!dsLinesSelected}
						onClose={onClose}
						onSave={save}
						open
						titleRes={titleRes}
						width={528}		
					>
						{{
							main: (
								<PushSettingsForm />
							),
						}}
					</SaveDialog>
				</PushFromStyleStoreeContext.Provider>
			)}
		</>
	);
});

export default PushFromStyleDialog;
